import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { FloatingTile, Tile } from 'www-cms';
import { DirectusDirective, generateImageUrl } from 'directus';
import { WWWConfig, WWW_CONFIG } from '../../shared/models/config.model';
import { ButtonLinkComponent } from 'building-blocks/button-link/button-link.component';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { ImageWithLoaderComponent } from '../components/image-with-loader/image-with-loader.component';
import { Router } from '@angular/router';

@Component({
  selector: 'ss-www-floating-tiles',
  imports: [
    CommonModule,
    ButtonLinkComponent,
    ImageWithLoaderComponent,
    DirectusDirective,
  ],
  templateUrl: './floating-tiles.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingTilesComponent extends BaseBuildingBlockComponent {
  private wwwConfig = inject<WWWConfig>(WWW_CONFIG);
  private router = inject(Router);

  @Input({ required: true })
  floatingTileData!: FloatingTile;

  trackByFn(index: number, item: Tile) {
    return item.id;
  }

  trackByButtons(index: number, item: any) {
    return item.id;
  }

  getImageUrl(tile: Tile) {
    return generateImageUrl(
      {
        src: tile.backgroundImage!.id,
        width: 640,
      },
      this.wwwConfig.baseAssetUrl
    );
  }

  get hasBackgroundImages() {
    return this.floatingTileData.tiles.some((tile) => !!tile.backgroundImage);
  }

  hasAnyProductName(): boolean {
    return this.floatingTileData?.tiles?.some((tile) => !!tile.productName);
  }

  get isNotHomeScreen() {
    return this.router.url !== '/';
  }

  override getBgClass(): LastItemBgClass {
    switch (this.floatingTileData.bottomBackgroundColor) {
      case 'white':
        return 'bg-white';
      case 'black':
        return 'bg-black';
      case 'gray':
        return 'bg-ss-www-background';
      default:
        return 'bg-ss-www-background';
    }
  }
}
